import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  IconButton,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Box,
  ListItemAvatar,
  Avatar,
  Tooltip,
} from '@material-ui/core';
import { Delete, Image } from '@material-ui/icons';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { deleteBundleOptionAction } from '../../../../actions/bundleOptionsAction';
import ReviewLabel from '../ReviewButton/ReviewLabel';
import useStyles from './BundleOptionStyles';
import BundleOptionEditDialog from './BundleOptionEditDialog';
import { dialogContexts } from '../../../../constants/constants';

const BundleOption = ({ bundleOption, deleteBundleOptionAction }) => {
  const classes = useStyles();
  const [openDialog, setOpenDialog] = useState(false);

  const handleDelete = () => {
    deleteBundleOptionAction(bundleOption.objectId);
  };

  return (
    <Box>
      <ListItem button onClick={() => setOpenDialog(true)}>
        <Box display='flex' gridColumnGap='20px'>
          <ListItemText
            primary={bundleOption.bundleOptionTitle}
            secondary={bundleOption.bundleOptionDescription}
          />
          <ReviewLabel importStatus={bundleOption?.importStatus} />
        </Box>
        <ListItemSecondaryAction>
          <Tooltip title='Delete option'>
            <IconButton edge='end' aria-label='delete' onClick={handleDelete}>
              <Delete />
            </IconButton>
          </Tooltip>
        </ListItemSecondaryAction>
      </ListItem>
      <BundleOptionEditDialog
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        bundleOption={bundleOption}
        dialogContext={dialogContexts.EDIT}
      />
    </Box>
  );
};

BundleOption.propTypes = {
  deleteBundleOptionAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      deleteBundleOptionAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(BundleOption);
